const userKey = 'arirang:user_token'
const subscribeKey = 'arirang:subscribe_token'
const passKey = 'arirang:user_pass'
const localesKey = 'arirang:locales'
const payKey = 'arirang:pay'

export const setToken = async (token: string): Promise<void> => {
	return localStorage.setItem(userKey, token)
}

export const getToken = async (): Promise<string | null> => {
	return localStorage.getItem(userKey)
}

export const removeToken = async (): Promise<void> => {
	return localStorage.removeItem(userKey)
}

export const setSubscribeToken = async (token: string): Promise<void> => {
	return localStorage.setItem(subscribeKey, token)
}

export const getSubscribeToken = async (): Promise<string | null> => {
	return localStorage.getItem(subscribeKey)
}

export const removeSubscribeToken = async (): Promise<void> => {
	return localStorage.removeItem(subscribeKey)
}

export const setUserPass = async (data: string): Promise<void> => {
	return localStorage.setItem(passKey, data)
}

export const getUserPass = async (): Promise<string | null> => {
	return localStorage.getItem(passKey)
}

export const removeUserPass = async (): Promise<void> => {
	return localStorage.removeItem(passKey)
}

export const setLocales = async (locales: string): Promise<void> => {
	return localStorage.setItem(localesKey, locales)
}

export const getLocales = async (): Promise<string | null> => {
	return localStorage.getItem(localesKey)
}

export const setPay = async (locales: string): Promise<void> => {
	return localStorage.setItem(payKey, locales)
}

export const getPay = async (): Promise<string | null> => {
	return localStorage.getItem(payKey)
}

export const removePay = async (): Promise<void> => {
	return localStorage.removeItem(payKey)
}
